//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter () {
      this.footer.link && go(this.footer.link, this.$router)
      this.$emit('on-click-footer')
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/card/index.vue